import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class MeApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.ME);
  }

  getMe() {
    return this.httpClient.get(`${this.getResourceUrl()}`, {
      withCredentials: true,
    });
  }

  updateMe(data) {
    return this.httpClient.patch(`${this.getResourceUrl()}`, data);
  }

  deactivateMe(data) {
    return this.httpClient.put(`${this.getResourceUrl()}deactivate/`, data);
  }
}

export default new MeApi();
